__turbopack_context__.v({
  "clearIcon": "SearchInput-module__di7_oG__clearIcon",
  "default": "SearchInput-module__di7_oG__default",
  "icon": "SearchInput-module__di7_oG__icon",
  "mobile": "SearchInput-module__di7_oG__mobile",
  "searchWrapper": "SearchInput-module__di7_oG__searchWrapper",
});
